<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-school map-marker"
            :class="{ active: active === fmLatlng }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @touchstart.prevent="onClick"
            v-outsideclick="outsideclick"
            v-bind="$attrs"
        >
            <i class="iconfont" :class="icon">
                <span class="count" v-if="data.count > 1">{{
                    data.count
                }}</span>
            </i>
            <div
                ref="pop"
                class="marker-pop"
                :class="{ bottom: popBottom }"
                :style="popStyle"
            >
                <span
                    ref="pointer"
                    class="pointer"
                    :style="pointerStyle"
                ></span>
                <ul class="school-list">
                    <li :key="item.id" v-for="item in data.items">
                        <div class="info">
                            <div class="left">
                                <p class="name">{{ item.name }}</p>
                                <span
                                    class="tip"
                                >{{ item.type }} ·
                                    {{ item.gradeRange }}</span>
                            </div>
                            <div class="right">
                                <div
                                    :class="{
                                        rating: true,
                                        high: item.gsRating > 9,
                                        middle:
                                            item.gsRating >= 6 &&
                                            item.gsRating <= 9
                                    }"
                                >
                                    {{ item.gsRating }}
                                </div>
                                <span class="tip">{{
                                    $t('md-house.outOf10')
                                }}</span>
                            </div>
                        </div>
                        <a
                            class="link"
                            :href="link(item)"
                            target="_blank"
                            @click="clickLink(item, $event)"
                            @touchend.stop="clickLink(item, $event)"
                            rel="noopener noreferrer"
                        >{{ $t('md-house.viewHomesInThisSchool') }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { mapState, mapActions } from '@/store/helpers';

import Marker from './marker';
import util from '../../../common/util';
import { ADD_KEYWORD_MUTATION } from '@/modules/md-search/_store/config';
import { buildUrl } from '@/router/index.js';
export default {
    emits: ['update:active'],
    mixins: [Marker],
    props: {
        icon: {
            type: String,
            default: 'icon-school2'
        }
    },
    computed: {
        ...mapState({
            'searchParamsWithMap': 'searchParamsWithMap'
        }),
        
    },
    inject: {
        isListing: {
            type: Boolean,
            default: false
        },
        conditionChange: {
            from: 'conditionChange',
            default: () => {}
        }
    },
    methods: {
        ...mapActions({
            'addKeywordMutation': ADD_KEYWORD_MUTATION
        }),
        
        outsideclick(e) {
            const tar = e.target;
            if (!util.closest(tar, '.marker-school')) {
                this.$emit('update:active', '');
            }
        },
        link(item) {
            let key = item.keywordType + ':' + item.label;
            return buildUrl({ name: 'listing', query: { key: key.replace(/\+/g, ' ') } });
        },
        clickLink(item, e) {
            if (this.isListing) {
                e.preventDefault();

                let keyword =
                    item.addressCity && item.addressState
                        ? `${item.name},${item.addressCity},${item.addressState}`
                        : item.name;
                this.addKeywordMutation({
                    keywordType: item.keywordType,
                    keyword: keyword
                });
                if (this.conditionChange) {
                    this.conditionChange({
                        condition: { ...this.searchParamsWithMap },
                        kee: 'key'
                    });
                }

                if (this.platform.isMobile) {
                    //  mobile click ， retract pop up
                    setTimeout(() => {
                        this.onMouseLeave();
                    }, 200);
                }
            }
        }
    },
    data: function() {
        return {
            type: 'school',
            markerClassName: 'map-school-wrapper'
        };
    },
 
};
</script>
